import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { Popup } from '@elfsight/widget-modal';
import { useData } from '../../data';
import { Post } from '../../post';
import { CardContainer } from '../../post/parts';
import { useSocialFeedSettings } from '../../utils';
import { PopupControl } from '../PopupControl';
import { usePopup } from '../PopupProvider';

const POPUP_WIDTH = 1500;

export const Classic = forwardRef<HTMLDivElement>((_, forwardingRef) => {
  const { isOpen, index, open, close } = usePopup();
  const { font, popupBackdropColor } = useSocialFeedSettings();
  const { data, next, hasNext } = useData();

  const handleChange = (increment: number) => async () => {
    const newIndex = index + increment;

    if (newIndex >= data.length) {
      if (hasNext) {
        await next();
        open(newIndex);

        return;
      }

      open(0);

      return;
    }

    if (newIndex < 0) {
      open(data.length - 1);

      return;
    }

    open(newIndex);
  };

  const currentData = data[index];

  if (!currentData) {
    return null;
  }

  return (
    <Popup
      withCloseControl
      fixed
      fit
      disableScroll
      closeOnOutsideClick
      closeOnEscape
      withoutTransition
      ref={forwardingRef}
      width={POPUP_WIDTH}
      margin={[40, 0]}
      show={isOpen}
      onCloseRequest={close}
      backdropColor={popupBackdropColor}
      closeControlPosition="outside"
      ariaLabel="Social Feed Popup"
    >
      <Content _font={font?.value}>
        <Post
          isInPopup
          data={data[index]}
          index={index}
          layout="popupClassic"
        />

        <PopupControl.Next onClick={handleChange(1)} />
        <PopupControl.Prev onClick={handleChange(-1)} />
      </Content>
    </Popup>
  );
});

const Content = styled.div<{
  _font?: string;
}>`
  position: relative;

  & ${CardContainer} {
    height: 800px;
    max-height: calc(100vh - 40px);
  }

  ${({ _font }) =>
    _font &&
    css`
      font-family: '${_font}';
    `};
`;
